import React from "react";

export interface ContentContainerProps {
  children: React.ReactNode;
  /**
   * Available max-width sizes:
   *
   * Semantic sizes:
   * - narrow: max-w-4xl (896px) - For focused content like forms, CTAs
   * - standard: max-w-6xl (1152px) - Default for most content
   * - wide: max-w-7xl (1280px) - For content that needs more space
   * - full: w-full (100%) - For full-width content
   *
   * Additional Tailwind sizes:
   * - sm: max-w-sm (384px)
   * - md: max-w-md (448px)
   * - lg: max-w-lg (512px)
   * - xl: max-w-xl (576px)
   * - 2xl: max-w-2xl (672px)
   * - 3xl: max-w-3xl (768px)
   * - 5xl: max-w-5xl (1024px)
   */
  maxWidth?:
    | "narrow"
    | "standard"
    | "wide"
    | "full"
    | "sm"
    | "md"
    | "lg"
    | "xl"
    | "2xl"
    | "3xl"
    | "5xl";
  /**
   * Add responsive padding when using full width
   */
  padding?: boolean;
  className?: string;
}

// Temporarily disabled max-width classes - using full width with padding instead
// const maxWidthClasses = {
//   // Semantic sizes
//   'narrow': 'max-w-4xl',  // 896px
//   'standard': 'max-w-6xl', // 1152px
//   'wide': 'max-w-7xl',     // 1280px
//   'full': 'w-full',        // 100%
//
//   // Additional Tailwind sizes
//   'sm': 'max-w-sm',        // 384px
//   'md': 'max-w-md',        // 448px
//   'lg': 'max-w-lg',        // 512px
//   'xl': 'max-w-xl',        // 576px
//   '2xl': 'max-w-2xl',      // 672px
//   '3xl': 'max-w-3xl',      // 768px
//   '5xl': 'max-w-5xl'       // 1024px
// };

export function ContentContainer({
  children,
  maxWidth: _maxWidth, // Accept but ignore
  padding: _padding, // Accept but ignore
  className = "",
}: ContentContainerProps) {
  // Use full width with no padding for true edge-to-edge sections

  return <div className={`w-full ${className}`}>{children}</div>;
}
